import { z } from "zod";
import { CreateOrderDeliveryStep } from "../../helpers/createOrderHelpers";

export const DeliveryValidationSchema: z.ZodType<CreateOrderDeliveryStep> = z
  .object({
    differentAddress: z.boolean(),
    validFrom: z.date(),
    validTo: z.date(),
    lastDeliveryDate: z.date().nullable(),
    description: z.string().nullable(),
    address: z.string(),
    postCode: z.string(),
    countryId: z.string(),
    place: z.string(),
  })
  .superRefine(({ address, postCode, countryId, place, differentAddress }, refinementContext) => {
    if (differentAddress && !address) {
      refinementContext.addIssue({
        code: z.ZodIssueCode.custom,
        message: "addressRequired",
        path: ["address"],
      });
    }
    if (differentAddress && !postCode) {
      refinementContext.addIssue({
        code: z.ZodIssueCode.custom,
        message: "postCodeRequired",
        path: ["postCode"],
      });
    }
    if (differentAddress && !countryId) {
      refinementContext.addIssue({
        code: z.ZodIssueCode.custom,
        message: "countryRequired",
        path: ["countryId"],
      });
    }
    if (differentAddress && !place) {
      refinementContext.addIssue({
        code: z.ZodIssueCode.custom,
        message: "placeRequired",
        path: ["place"],
      });
    }
  });

export type DeliveryStepInput = z.infer<typeof DeliveryValidationSchema>;
